import { Typography } from "@packages/ds";
import styled from "styled-components";

import { AddButton as DsAddButton } from "ds/Button";

export const EmptyDomainsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  color: var(--section-ebony-light-color, var(--ebony-light));
  background: var(--section-snow-background-color, var(--snow));
  min-height: 372px;

  padding: 20px 32px 14px 32px;
  .copyable {
    width: 80%;
  }
`;
export const Title = styled(Typography.Title)`
  padding-top: 60px;
  padding-bottom: 16px;
`;

export const SubTitle = styled(Typography.BodyText)`
  padding-left: 170px;
  padding-right: 170px;
  padding-bottom: 40px;
  text-align: center;
`;

export const AddButton = styled(DsAddButton)`
  float: right;
`;
